import { EntityApiService } from '@dofleini/security';

import { authentication } from '@/settings';

class NotaryOfficesApiService extends EntityApiService {
}

export default new NotaryOfficesApiService(`${authentication.path}/api/notary-offices`);
